import React from 'react';
import styles from './form-button-back.module.scss';
import { useNavigate } from 'react-router-dom';

export const FormButtonBack: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <button className={styles.form_button_back} onClick={handleBackClick}>
      Назад
    </button>
  );
};
